import { TagMessageType } from 'container/SalesOrder'
import { ErrorMessage } from 'store/AuthContext/Types/authSliceType'

const HAVPhoneNumber = '(11) 3847-7477'

const errorMessages = {
  invalidField: 'Campo inválido',
  emptyField: 'Campo obrigatório',
  invalidTerm: 'Prazo Inválido',
  expiredLogin: 'Login expirado.'
}

const authRetCod = {
  requireValidation: '0',
  incompleteValidation: '99',
  deniedAccess: '1001',
  inactiveUser: '1004',
  expiredPassword: '1007',
  incorrectCredentials: '1014',
  PasswordBlock1: '1015',
  PasswordBlock2: '1016',
  invalidUser: '1018'
} as const

type DescriptionsRetCod = keyof typeof authRetCod
export type AuthRetCodKeys = typeof authRetCod[DescriptionsRetCod]

type AuthErrorsType = Record<AuthRetCodKeys, ErrorMessage>

const authErrors: AuthErrorsType = {
  [authRetCod.requireValidation]: {
    title: 'Confirmação necessária.',
    description: 'Autentique seu login usando o código enviado por email.'
  },
  [authRetCod.incompleteValidation]: {
    title: 'Confirmação pendente.',
    description: 'Autentique seu login usando o código enviado por email.'
  },
  [authRetCod.incorrectCredentials]: {
    title: 'Usuário ou senha incorretos.',
    description:
      'Caso insira a senha incorreta três vezes consecutivas, sua conta será automaticamente bloqueada. Para recuperar o acesso, será necessário redefinir sua senha.'
  },
  [authRetCod.expiredPassword]: {
    title: 'Senha expirada.',
    description:
      'Sua senha está expirada, você será redirecionado para uma página onde poderá atualizá-la'
  },
  [authRetCod.deniedAccess]: {
    title: 'Acesso negado.',
    description: 'Entre em contato com o backoffice para saber mais.'
  },
  [authRetCod.inactiveUser]: {
    title: 'Conta desativada.',
    description: 'Entre em contato com o backoffice para saber mais.'
  },
  [authRetCod.PasswordBlock1]: {
    title: 'Conta bloqueada.',
    description:
      'Sua senha foi inserida incorretamente três ou mais vezes consecutivas, por isso sua conta foi bloqueada.'
  },
  [authRetCod.PasswordBlock2]: {
    title: 'Conta bloqueada.',
    description:
      'Sua senha foi inserida incorretamente três ou mais vezes consecutivas, por isso sua conta foi bloqueada.'
  },
  [authRetCod.invalidUser]: {
    title: 'Usuário não cadastrado.',
    description: 'Entre em contato com o backoffice para saber mais.'
  }
} as const

const unknownError = () => {
  return {
    title: 'Erro desconhecido.',
    description: `Tente novamente ou ligue para ${HAVPhoneNumber}`
  }
}

interface MTOTagsInterface {
  MTOCustomization: TagMessageType
  OUTLineFlag: TagMessageType
}
const MTOTags: MTOTagsInterface = {
  MTOCustomization: 'MTO - PREPARAÇÃO',
  OUTLineFlag: 'FORA DE LINHA'
}

const invalidEmailDomainError: ErrorMessage = {
  title: 'Domínio de email inválido',
  description:
    'Não é permitido entrar com email com esse domínio. Troque o tipo de usuário.'
}

export {
  HAVPhoneNumber,
  unknownError,
  authErrors,
  errorMessages,
  MTOTags,
  authRetCod,
  invalidEmailDomainError
}
